export default "__VITE_ASSET__6NQJ0kpj__"